import { SERVICE_LIST, SERVICE_LIST_ERROR, SERVICE_LIST_HIDE_ERROR, SERVICE_LIST_START_LOADER, SERVICE_LIST_STOP_LOADER, } from "../interface/IServiceList";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ServiceListReducer = (state = initState, action) => {
    switch (action.type) {
        case SERVICE_LIST: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case SERVICE_LIST_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SERVICE_LIST_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case SERVICE_LIST_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case SERVICE_LIST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ServiceListReducer;
